import styled from 'styled-components';
import { tvar } from '../..';

interface StyledHorizontalLayoutProps {
  gap?: string;
}

export const StyledHorizontalLayout = styled.div<StyledHorizontalLayoutProps>`
  display: flex;
  align-items: flex-end;
  gap: ${(props) => props.gap || tvar('space.x2')};

  legend {
    margin-bottom: 0;
  }
`;
